export default {
    userPermissionReadAllSuccess(state, permissions) {
        state.userPermissions = permissions;
    },

    userPermissionReadErr(state, err) {
        state.error = err;
    },
};